import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import React, { useCallback } from 'react'

import { MinusCircle, PlusCircle } from '@phosphor-icons/react'
import { Row, Text } from 'Components/UI'
import { AnimatePresence, motion } from 'framer-motion'

import { TRANSITION } from 'Constants/Animations'

import { useResponsiveLayout } from 'Hooks'

import { Container, StyledButton } from './styles'

type Props = {
  isOpen?: boolean
  data?: { question?: string; answer?: string }
  onClose?: () => void
  onOpen?: () => void
}

function FAQAccordion({ data, isOpen, onClose, onOpen }: Props) {
  const { isDesktop } = useResponsiveLayout()

  const handleButtonClick = useCallback(() => {
    if (isOpen) {
      onClose?.()
    } else {
      onOpen?.()
    }
  }, [isOpen, onClose, onOpen])

  if (!data || !data.question || !data.answer) return null

  return (
    <Container>
      <StyledButton onClick={handleButtonClick}>
        <Text left medium screen16={!isDesktop} screen20={isDesktop}>
          {data.question}
        </Text>

        {isOpen ? (
          <MinusCircle size={24} weight="fill" />
        ) : (
          <PlusCircle size={24} weight="fill" />
        )}
      </StyledButton>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            animate="open"
            exit="collapsed"
            initial="collapsed"
            key="content"
            style={{ overflow: 'hidden' }}
            transition={TRANSITION.DEFAULT}
            variants={{
              open: { height: 'auto', opacity: 1 },
              collapsed: { height: 0, opacity: 0 },
            }}
          >
            <Row pr={11} pt={5}>
              <Text
                body
                preWrap
                regular
                screen14={!isDesktop}
                screen18={isDesktop}
              >
                {data.answer}
              </Text>
            </Row>
          </motion.div>
        )}
      </AnimatePresence>
    </Container>
  )
}

export default FAQAccordion
